<template>
  <v-flex xs12 class="text-xs-center" v-if="$store.state.sites.loadingSites">
    <v-progress-circular indeterminate :color="$store.state.global.pages[$route.name].color"></v-progress-circular>
  </v-flex>
  <transition name="fadeToggle" mode="out-in" v-else>
    <v-flex xs12 v-if="listView">
      <v-card hover>
        <v-data-table
          :items="filteredSites"
          :headers="headers"
          :rows-per-page-items="itemsPerPageOptions"
        >
          <template slot="items" slot-scope="props">
            <table-row :headers="headers" :row="props.item" parent="Site" :key="props.item.id"></table-row>
          </template>
        </v-data-table>
      </v-card>
    </v-flex>

    <transition-group name="data-list" tag="layout-no-padding" v-else>
      <v-flex
        xs12
        sm6
        md4
        xl3
        v-for="(site,i) in filteredSites"
        :key="site.id"
        class="data-list-item"
      >
        <site-card :site="site" :index="i"></site-card>
      </v-flex>
    </transition-group>
  </transition>
</template>

<script>
import Store from '@/store/computed/storeHelpers'
import SiteService from '@/services/requests/siteService'
import SiteCard from '@/components/sites/siteCard'
import TableRow from '@/components/ui/masterFileTableRow'
export default {
  data() {
    return {
      headers: [
        {
          text: 'Name',
          align: 'left',
          value: 'name'
        },
        {
          text: 'Email',
          align: 'left',
          value: 'contactEmail'
        },
        {
          text: 'Phone',
          align: 'left',
          value: 'contactPhone'
        },
        {
          text: 'Project',
          align: 'right',
          value: 'project.name'
        },
        {
          text: 'Actions',
          align: 'center',
          sortable: false
        }
      ]
    }
  },
  computed: {
    sortBy: Store.getSet({ store: 'sites', prop: 'sortBy' }),
    filterBy: Store.getSet({ store: 'sites', prop: 'filterBy' }),
    listView: Store.getSet({ store: 'sites', prop: 'listView' }),
    sites: Store.getSet({ store: 'sites', prop: 'sites' }),
    project: Store.getSet({ store: 'sites', prop: 'project' }),
    selectedRecordType: Store.getSet({
      store: 'sites',
      prop: 'selectedRecordType'
    }),
    projectFilteredSites() {
      if (!!this.project) {
        return this.sites.filter(site => {
          return site.projectId == this.project
        })
      } else {
        return this.sites
      }
    },
    sortedSites() {
      if (this.sortBy) {
        var path = this.sortBy
        return this.projectFilteredSites.sort((a, b) => {
          //if(a[property] < b[property])
          if (this.getObjectPath(path, a) < this.getObjectPath(path, b)) {
            if (path == 'updatedAt') {
              return 1
            }
            return -1
          } else {
            if (path == 'updatedAt') {
              return -1
            }
            return 1
          }
        })
      } else {
        return this.projectFilteredSites
      }
    },
    filteredSites() {
      return this.sortedSites.filter(site => {
        const searchMatch =
          site.name.toLowerCase().indexOf(this.filterBy.toLowerCase()) > -1
        if (this.selectedRecordType === 'Request')
          return searchMatch && site.request
        else return searchMatch && !site.request
      })
      //return this.sortedSites;
    }
  },
  components: {
    SiteCard,
    TableRow
  }
}
</script>

<style scoped>
</style>
